export default {
  chat: 'chat',
  newgptchat: 'chat',
  supportchat: 'supportchat',
  chats: 'chats',
  profile: 'profile',
  myprofile: 'profile',
  subscriptions: 'subscriptions',
}
